export  enum ApiQueryEnum {
    NORMATIVOS = "normativos?q=",
    NORMATIVOS_QUERY = "normativos/query?q=",
    NORMATIVOS_QUERY_OR_SIMPLE = "normativos/query-or-simple?q=",
    NORMATIVOS_QUERY_OR_SIMPLE_VALIDACAO_LINK_FONTE = "normativos/query-or-simple/validacao-link-fonte?q=",
    DOWNLOAD_RESULTADO = "normativos/download/?q=",
    TIPOS_NORMATIVOS = "/tipos-normativos",
    NORMATIVO ="/normativo?id=",
    APRESENTACAO = "/normativo/apresentacao/",
    APRESENTACAO_CONSOLIDADO = "/normativo/apresentacao/consolidado/",
    NORMATIVO_DESTAQUES = "/normativos/destaques",
    NORMATIVO_RECENTES = "/normativos/ultimos-registros",
    DOCUMENTO ="/documento/",
    VISUALIZADOR ="/visualizador/",
    VISUALIZADOR_HTML ="/visualizador/html/",
    NORMATIVOS_ID_QUERY = "/normativo/id/{0}/query/{1}",
}
export default ApiQueryEnum;